import { render, staticRenderFns } from "./PPThome.vue?vue&type=template&id=7b385680&scoped=true&"
import script from "./PPThome.vue?vue&type=script&lang=js&"
export * from "./PPThome.vue?vue&type=script&lang=js&"
import style0 from "./PPThome.vue?vue&type=style&index=0&id=7b385680&scoped=true&lang=css&"
import style1 from "./PPThome.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b385680",
  null
  
)

export default component.exports